import { useNavigate } from 'react-router-dom';

import { Integration } from 'lib/types';

import Button from 'components/Button/Button';
import Table from 'components/Table/Table';
import { Cell, Row } from 'gridjs';
import { _ } from 'gridjs-react';
import { useSelector } from 'react-redux';
import { selectCanManageLicenses } from 'reducers/credentials/selectors';

function LicenseList(props: LicenseListProps) {
    const { integration } = props;
    const navigate = useNavigate();

    const handleNewLicenseClicked = () => {
        navigate(`/integrations/${integration.id}/licenses/create-license`);
    };

    const canManageLicenses = useSelector(selectCanManageLicenses);

    const columns = [
        { id: 'id', name: 'ID' },
        {
            id: 'softwareLicenseCode',
            name: 'Software License Code',
            formatter: (cell: Cell, row: Row) => canManageLicenses
                ? _(
                    <a
                    href="#"
                        onClick={(e) =>
                            {
                             e.preventDefault();   
                            navigate(
                                `/integrations/${integration.id}/licenses/${row.cells[0].data}/edit`
                            )
                            }
                        }
                    >
                        {cell}
                    </a>
                )
                : _(
                    <div>
                        {cell}
                    </div>
                ),
        },
        {
            id: 'licenseType',
            name: 'License Type',
        },
        {
            id: 'count',
            name: 'Count',
        },
        {
            id: 'expireDate',
            name: 'Expire Date',
        },
        {
            id: 'customData',
            name: 'Custom Data',
        },
    ];

    const data = integration.licenses ?? [];

    return (
        <div>
            <Table
                columns={columns}
                data={data}
                pagination={{ enabled: true, limit: 10 }}
                search={{ enabled: true }}
            />
            { canManageLicenses && <Button color="secondary" onClick={handleNewLicenseClicked}>
                Add new license
            </Button> }
        </div>
    );
}

type LicenseListProps = {
    integration: Integration;
};

export default LicenseList;
